@if (
  {
    activities: activities$ | async,
    idsOfFirstActivityPerDay: idsOfFirstActivityPerDay$ | async,
  };
  as state
) {
  @if (state.activities === null) {
    <div>
      <div class="spinner-container">
        <div class="spinner">
          <mat-progress-spinner
            [strokeWidth]="3"
            [diameter]="30"
            [color]="'primary'"
            [mode]="'indeterminate'"
          >
          </mat-progress-spinner>
        </div>
      </div>
    </div>
  }
  @if (state.activities?.length === 0) {
    <div class="empty-message">
      <app-activity-feed-empty></app-activity-feed-empty>
    </div>
  }
  @if (state.activities && state.activities?.length !== 0) {
    <div class="list">
      @for (activity of state.activities; track activity) {
        <div>
          @if (state.idsOfFirstActivityPerDay?.has(activity.id)) {
            <div class="date">
              {{ activity.timeStampUtc | dateFormat: "relativeDay" }}
            </div>
          }
          <div mat-ripple class="celo-hoverable item">
            <app-activity-feed-list-item
              [activity]="activity"
            ></app-activity-feed-list-item>
          </div>
        </div>
      }
    </div>
  }
}
